import _ from 'lodash'
import { diff } from '../lib/render-object'
import codeService from 'data/codes'

const mapper = (text) => {
  return {
    'usergroups': 'User Groups',
    'portfolioreportingdefaults': 'Portfolio Reporting Defaults',
    'userdefaults': 'User Defaults',
    'usergroupdefaults': 'User Group Defaults',
  }[text] || _.startCase(text)
}

const alwaysDrop = [
  "externalreference",
  "organizationid",
  "notedetail",
  "status",
  "systeminput",
  "permissions",
  "portfolioid"
]

export const diffif = (props) => {
  if (props.resource !== 'portfolio') return null

  return () => {
    const codes = codeService.value()
    let change = JSON.parse(props.change)
    if (change.old) change.old.assets = _.map(change.old.assets, id => _.find(codes.asset, {id})?.code || id)
    if (change.new) change.new.assets = _.map(change.new.assets, id => _.find(codes.asset, {id})?.code || id)
    const diffs = diff(change.old, change.new, mapper, null, alwaysDrop)

    const atRest =
      props.method == 'POST' ? 'Created Portfolio' : 
      props.method == 'DELETE' ? 'Deleted Portfolio' : 'Portfolio Change'

    return {diffs, atRest, ...props}
  }
}